module.exports = __webpack_public_path__ + "img/level_18_elite.6dd0ff59.svg";